import React from "react"
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const defaultState = {
  dark: false,
  toggleDark: () => {},
  menuExpanded: false,
  toggleExpanded: () => {},
}

const ThemeContext = React.createContext(defaultState)

// Getting dark mode information from OS!
// You need macOS Mojave + Safari Technology Preview Release 68 to test this currently.
const supportsDarkMode = () =>
  window.matchMedia("(prefers-color-scheme: dark)").matches === true

class ThemeProvider extends React.Component {
  targetElement = null;

  state = {
    menuExpanded: false,
    dark: false,
  }

  toggleDark = () => {
    let dark = !this.state.dark
    localStorage.setItem("dark", JSON.stringify(dark))
    this.setState({ dark })
  }

  toggleExpanded = () => {
    this.setState({menuExpanded: !this.state.menuExpanded})

    if (!this.state.menuExpanded) {
      disableBodyScroll(this.targetElement);
    }
    else {
      enableBodyScroll(this.targetElement);
    }
  }

  componentDidMount() {
    // Getting dark mode value from localStorage!
    const lsDark = JSON.parse(localStorage.getItem("dark"))
    if (lsDark) {
      this.setState({ dark: lsDark })
    } else if (supportsDarkMode()) {
      this.setState({ dark: true })
    }

    this.targetElement = document.querySelector('#___gatsby');
  }

  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }

  render() {
    const { children } = this.props
    const { dark, menuExpanded } = this.state
    return (
      <ThemeContext.Provider
        value={{
          dark,
          toggleDark: this.toggleDark,
          menuExpanded,
          toggleExpanded: this.toggleExpanded,
        }}
      >
        {children}
      </ThemeContext.Provider>
    )
  }
}

export default ThemeContext

export { ThemeProvider }